/**
 * File: App.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.3.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { BrowserRouter, Routes, useLocation } from "react-router-dom";
import { useLayoutEffect, useState } from "react";

// Local project files
import "./styles/app.css";
import Footer from "./components/layout/Footer";
import HomeHeader from "./components/layout/HomeHeader";
import { renderUserRoutes } from "./routes/renderUserRoutes";
import { renderPublicRoutes } from "./routes/renderPublicRoutes";
import { routes } from "./constants/routes";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function AppLayout() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    });

    const location = useLocation();
    const authRoutes = [
        routes.public.auth.recovery.abs,
        routes.public.auth.reset.abs,
        routes.public.auth.signIn.abs,
        routes.public.auth.signUp.abs,
        routes.public.auth.verify.abs,
    ];
    const isAuthPage = authRoutes.includes(location.pathname);

    const [isUserAuth, setIsUserAuth] = useState(false);

    if (!authRoutes.includes(window.location.pathname)) {
        document.body.classList.remove("page--gray");
        document.body.classList.add("page--white");
    } else {
        document.body.classList.remove("page--white");
        document.body.classList.add("page--gray");
    }

    return (
        <>
            {!isAuthPage && !isUserAuth && (
                <header>
                    <div className="app-layout__container">
                        <HomeHeader />
                    </div>
                </header>
            )}
            <main className={isUserAuth ? "app-layout__main--auth-user" : ""}>
                <section>
                    <Routes>
                        {renderPublicRoutes(setIsUserAuth)}
                        {renderUserRoutes(isUserAuth)}
                    </Routes>
                </section>
            </main>
            {!isAuthPage && !isUserAuth && (
                <footer>
                    <div className="app-layout__container">
                        <Footer />
                    </div>
                </footer>
            )}
        </>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppLayout />
        </BrowserRouter>
    );
}

export default App;
